module.exports = __webpack_public_path__ + "static/img/zhihuitingchechang.e71f828f.png";